import { Injectable } from '@angular/core';

export const NPS_CONSTRAINTS = {
  monthlyContribution: { min: 500, max: 500_000, step: 500 },
  rate:                { min: 1,   max: 15,       step: 0.1 },
  age:                 { min: 18,  max: 59,       step: 1   },
  annuityPercent:      { min: 40,  max: 100,      step: 5   },
  annuityRate:          { min: 3,   max: 10,       step: 0.1 }
} as const;

export interface NpsYearRow {
  year: number;
  age: number;
  invested: number;
  balance: number;
}

export interface NpsResult {
  years: NpsYearRow[];
  totalInvested: number;
  totalGain: number;
  corpus: number;
  lumpsumAmount: number;
  annuityAmount: number;
  monthlyPension: number;
}

@Injectable({ providedIn: 'root' })
export class NpsCalculatorService {

  calculate(
    currentAge: number,
    retirementAge: number,
    monthlyContribution: number,
    annualRate: number,
    annuityPercent: number,
    annuityRate: number
  ): NpsResult {
    const i = annualRate / 100 / 12;
    const totalMonths = (retirementAge - currentAge) * 12;

    let balance = 0;
    let invested = 0;
    const years: NpsYearRow[] = [];

    for (let m = 1; m <= totalMonths; m++) {
      balance = (balance + monthlyContribution) * (1 + i);
      invested += monthlyContribution;
      if (m % 12 === 0) {
        years.push({ year: m / 12, age: currentAge + m / 12, invested, balance });
      }
    }

    const corpus = balance;
    const annuityAmount = corpus * (annuityPercent / 100);
    const lumpsumAmount = corpus - annuityAmount;
    const monthlyPension = (annuityAmount * (annuityRate / 100)) / 12;

    return {
      years,
      totalInvested: invested,
      totalGain: corpus - invested,
      corpus,
      lumpsumAmount,
      annuityAmount,
      monthlyPension
    };
  }
}
